import React from 'react';
import { useLanguage } from '../context/LanguageContext';

/**
 * Skip Link Component - Melhora navegação por teclado
 * Permite usuários de teclado/screen readers pularem diretamente para conteúdo principal
 */
const SkipLink = ({ targetId = 'main-content' }) => {
  const { language } = useLanguage();
  
  const text = language === 'pt' 
    ? 'Saltar para o conteúdo principal' 
    : 'Skip to main content';

  return (
    <a
      href={`#${targetId}`}
      className="sr-only sr-only-focusable fixed top-4 left-4 z-[9999] bg-pink-600 text-white px-4 py-2 rounded-lg font-semibold shadow-lg focus:not-sr-only"
    >
      {text}
    </a>
  );
};

export default SkipLink;
